import React from 'react';
import { Helmet } from 'react-helmet-async';
import { absoluteUrl, BUSINESS } from '../lib/site';

const SEO = ({ 
  title, 
  description, 
  canonical,
  image,
  type = 'website',
  noindex = false
}) => {
  const siteName = 'Paint It Better';
  const canonicalUrl = canonical ? absoluteUrl(canonical) : null;
  // Every page gets a picture when shared on Facebook, WhatsApp etc.
  const imageUrl = absoluteUrl(image || BUSINESS.shareImage);
  
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex" />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteName} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      <meta property="og:image" content={imageUrl} />
      {!image && <meta property="og:image:width" content="1200" />}
      {!image && <meta property="og:image:height" content="630" />}
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      
      {/* Local Business */}
      <meta name="geo.region" content="GB-KEN" />
      <meta name="geo.placename" content="Wye, Kent" />
    </Helmet>
  );
};

export default SEO;
